import { render, staticRenderFns } from "./ConfigureAuctionModal.vue?vue&type=template&id=6b3568c8&scoped=true"
import script from "./ConfigureAuctionModal.vue?vue&type=script&lang=js"
export * from "./ConfigureAuctionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3568c8",
  null
  
)

export default component.exports